import React from 'react';

// Spacer component to take up available space
const Spacer = () => (
    <span style={{ flex: "1" }}></span>
)

export default Spacer;